import React from "react";
import { ContentSection, ensure, ListTable, Stack } from "sprint-common-web";

import { useGetOnPremOrderDashboard } from "../hooks/useGetOnPremOrderDashboard";
import { createOnPremOrderAssetsSectionColumns } from "./createOnPremOrderAssetsSectionColumns";
import { mapToOnPremOrderDaschboardAssetsItems } from "./OnPremOrderAssetItem";

interface OnPremOrderAssetsSectionProps {
    minHeight: number;
}

export const OnPremOrderAssetsSection: React.VFC<OnPremOrderAssetsSectionProps> = ({
    minHeight
}: OnPremOrderAssetsSectionProps) => {
    const { isLoading, onPremOrderDetails, areNotesLoading } = useGetOnPremOrderDashboard();

    const columns = createOnPremOrderAssetsSectionColumns({ areNotesLoading });

    return (
        <ContentSection header="Assets" style={{ minHeight }} data-testId="onprem-order-assets-section">
            <Stack style={{ overflowY: "auto" }}>
                <ListTable
                    columns={columns}
                    items={mapToOnPremOrderDaschboardAssetsItems(onPremOrderDetails)}
                    isLoading={isLoading}
                    testId="onprem-order-assets-list"
                    shimmerLines={1}
                    noItemsMessage="No assets"
                    onRenderRow={(props, defaultRender) => {
                        ensure(props);
                        ensure(defaultRender);

                        const testProps = {
                            "data-testid": "table-row",
                            "data-testkey": props.item.id,
                            "data-testdisabled": props.item.isDisabled
                        };

                        return defaultRender({ ...props, ...testProps, styles: { root: { border: "none" } } });
                    }}
                />
            </Stack>
        </ContentSection>
    );
};
